import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import kaTranslation from './locales/ka/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      ka: {
        translation: kaTranslation
      }
    },
    lng: 'en', // default language
    fallbackLng: 'en', // use english if selected language is not available
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;